import { render, staticRenderFns } from "./setHead.vue?vue&type=template&id=37f9ca97&scoped=true&"
import script from "./setHead.vue?vue&type=script&lang=js&"
export * from "./setHead.vue?vue&type=script&lang=js&"
import style0 from "./setHead.vue?vue&type=style&index=0&id=37f9ca97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f9ca97",
  null
  
)

export default component.exports